import { render, staticRenderFns } from "./staff-manage.vue?vue&type=template&id=27291b58&scoped=true&"
import script from "./staff-manage.vue?vue&type=script&lang=js&"
export * from "./staff-manage.vue?vue&type=script&lang=js&"
import style0 from "./staff-manage.vue?vue&type=style&index=0&id=27291b58&prod&lang=css&"
import style1 from "./staff-manage.vue?vue&type=style&index=1&id=27291b58&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27291b58",
  null
  
)

export default component.exports